import React from 'react';
import { InstagramIcon, LinkedinIcon, YoutubeIcon, MailIcon } from 'lucide-react';
export function Footer() {
  const socialLinks = [{
    icon: InstagramIcon,
    href: 'https://www.instagram.com/learndesign.app',
    label: 'Instagram'
  }, {
    icon: LinkedinIcon,
    href: 'https://www.linkedin.com/company/learndesign',
    label: 'LinkedIn'
  }, {
    icon: YoutubeIcon,
    href: 'https://www.youtube.com/@learndesign_app',
    label: 'YouTube'
  }];
  return <footer className="bg-dark-950 border-t border-white/5" data-id="element-136">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-137">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-138">
          {/* Brand column */}
          <div data-id="element-139">
            <a href="#" className="inline-block mb-6" data-id="element-140">
              <img src="https://cdn.magicpatterns.com/uploads/gh8LMhSDnKan7GYLYw8oaP/LeaDe_Brand_assets-01.svg" alt="LeaDe Academy" className="h-10 w-auto" data-id="element-141" />
            </a>
            <p className="text-gray-400 mb-6 max-w-sm" data-id="element-142">
              The premier online academy for aspiring product designers. Master
              Figma, Framer, and AI-powered design in.
            </p>

            {/* Newsletter */}
            <div className="mb-6" data-id="element-143">
              <p className="text-sm font-medium text-white mb-3" data-id="element-144">
                Get design and career tips in your inbox
              </p>
              <form className="flex gap-2" data-id="element-145">
                <div className="relative flex-1" data-id="element-146">
                  <MailIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" data-id="element-147" />
                  <input type="email" placeholder="Enter your email" className="w-full pl-10 pr-4 py-3 bg-dark-800 border border-white/10 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-brand-yellow/50 transition-colors" data-id="element-148" />
                </div>
                <button type="submit" className="px-4 py-3 bg-brand-yellow text-dark-900 font-medium rounded-lg hover:bg-brand-yellow-dark transition-colors" data-id="element-149">
                  Subscribe
                </button>
              </form>
            </div>

            {/* Social links */}
            <div className="flex gap-4" data-id="element-150">
              {socialLinks.map(social => <a key={social.label} href={social.href} aria-label={social.label} className="w-10 h-10 rounded-lg bg-dark-800 flex items-center justify-center text-gray-400 hover:text-brand-yellow hover:bg-dark-700 transition-colors" data-id="element-151">
                  <social.icon className="w-5 h-5" data-id="element-152" />
                </a>)}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-153">
          <p className="text-sm text-gray-500" data-id="element-154">
            © {new Date().getFullYear()} LeaDe Academy. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-gray-500" data-id="element-155">
            <span className="flex items-center gap-2" data-id="element-156">
              <span className="w-2 h-2 rounded-full bg-green-500" data-id="element-157" />
              All systems operational
            </span>
          </div>
        </div>
      </div>
    </footer>;
}